import React from 'react';
import { useStateMethods } from '../../providers/state';
import { stateKeys } from '../../constants/stateKeys';
import IconTemplate from './IconTemplate';

const ImageIcon = ({ attachment }) => {
  const { setState } = useStateMethods();

  const handleClick = () => {
    setState((prev) => {
      const indexes = prev[stateKeys.imageIndexes];
      const index = indexes.get(attachment.id);

      return {
        [stateKeys.selectedImageIndex]: index,
        [stateKeys.showLightbox]: true,
      };
    });
  };

  return (
    <IconTemplate
      tooltipTitle="Просмотр"
      iconType="file-image"
      onClick={handleClick}
    />
  );
};

export default ImageIcon;
